/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { PolymerTypeAtomRoleId, getMoleculeType } from './model/types';
import { Vec3 } from '../../mol-math/linear-algebra';
export function getCoarseBegCompId(unit, element) {
  var entityKey = unit.coarseElements.entityKey[element];
  var seq = unit.model.sequence.byEntityKey[entityKey].sequence;
  var seq_id_begin = unit.coarseElements.seq_id_begin.value(element);
  return seq.compId.value(seq_id_begin - 1); // 1-indexed
}
export function getElementMoleculeType(unit, element) {
  switch (unit.kind) {
    case 0
    /* Atomic */
    :
      return unit.model.atomicHierarchy.derived.residue.moleculeType[unit.residueIndex[element]];

    case 1
    /* Spheres */
    :
    case 2
    /* Gaussians */
    :
      // TODO add unit.model.coarseHierarchy.derived.residue.moleculeType
      var compId = getCoarseBegCompId(unit, element);
      var cc = unit.model.properties.chemicalComponentMap.get(compId);
      if (cc) return getMoleculeType(cc.type, compId);
  }

  return 0
  /* Unknown */
  ;
}
export function getAtomicMoleculeType(model, rI) {
  return model.atomicHierarchy.derived.residue.moleculeType[rI];
}
var EmptyAtomIds = new Set();
export function getAtomIdForAtomRole(polymerType, atomRole) {
  var p = PolymerTypeAtomRoleId[polymerType];

  if (p !== undefined) {
    var a = p[atomRole];
    if (a !== undefined) return a;
  }

  return EmptyAtomIds;
}
var tmpPositionsVec = Vec3.zero();
export function getPositions(unit, indices) {
  var pos = unit.conformation.position;
  var positions = new Float32Array(indices.length * 3);
  var elements = unit.elements;

  for (var i = 0, il = indices.length; i < il; ++i) {
    pos(elements[indices[i]], tmpPositionsVec);
    Vec3.toArray(tmpPositionsVec, positions, i * 3);
  }

  return positions;
}